import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ListViewHelper } from '../components/list-view/list-view.helper';
import { BrowserStorageService } from '../services/browserstorage.service';
import { CurrentFolderService } from '../services/current-folder.service';
import { FolderService } from '../services/folder.service';

@Injectable()
export class FolderResolver implements Resolve<any> {
    constructor(
        private folderService: FolderService,
        private currentFolderService: CurrentFolderService,
        private localStorageService: BrowserStorageService,
        private readonly titleService: Title) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        let userIsLoadingForm = state.url.indexOf('/form/') > -1;
        if (route.url.length == 0) {
            if (route.parent.parent.data &&
                route.parent.parent.data.currentSite &&
                route.parent.parent.data.currentSite.folders &&
                route.parent.parent.data.currentSite.folders.length > 0) {

                let rootFolder = route.parent.parent.data.currentSite.getRootFolder();

                if (rootFolder && this.currentFolderService.isCurrentFolder(rootFolder.id)) {
                    return new Promise<any>((resolve, reject) => {
                        setTimeout(() => {
                            resolve(rootFolder);
                        }, 0);
                    });
                } else {
                    let siteId = route.parent.parent.params['id'];

                    return this.folderService.getRootFolderForSite(siteId).then(folder => {
                        this.currentFolderService.Folder = folder;
                        this.titleService.setTitle(environment.sitename + ': Structure');
                        return folder;
                    });
                }
            }
        } else {
            let folderId = this.getFolderIdFromUrl(state.url);
            // pharv - 11/09/2021 - introduced use of CurrentFolderService (see comments in StructureComponent)
            if (!this.currentFolderService.isCurrentFolder(folderId)) {
                if (ListViewHelper.APP_WIDE_INFINITE_SCROLL_ENABLED && !userIsLoadingForm) {
                    // don't show progress bar if the url is for a Form. This ensures that the
                    // display for "Form Loading" progress message doesn't get interupted
                    return this.folderService.getWithPagination(folderId, true).then(folder => {
                        this.currentFolderService.Folder = folder;
                        this.titleService.setTitle(environment.sitename + ': ' + folder.name);
                        return folder;
                    });
                } else {
                    // 03-06-2025 note:  replacing the following call to folderService.get() with
                    //                   a call to new method folderService.getForFolderResolver().
                    /*
                    return this.folderService.get(folderId).then(folder => {
                        this.currentFolderService.Folder = folder;
                        this.titleService.setTitle(environment.sitename + ': ' + folder.name);
                        return folder;
                    });
                    */
                    return this.folderService.getForFolderResolver(folderId).then(folder => {
                        this.currentFolderService.Folder = folder; 
                        this.titleService.setTitle(environment.sitename + ': ' + folder.name);
                        return folder;
                    });
                }
            } else {
                var promise = new Promise<any>((resolve, reject) => {
                    setTimeout(() => {
                        resolve(this.currentFolderService.Folder);
                    }, 0);
                });

                return (promise);
            }

        }
        return null;

    }

    private requestIsForForm(state: RouterStateSnapshot) {
        return state.url.match(/\/folder\/\d*\/form\/\d*/);
    }

    // url will be of the form site/123/folder/234 OR site/123/folder/234/form/345
    private getFolderIdFromUrl(url: String): number {
        let parts: string[] = url.split('/');

        var folderIdPart: string = null;
        var partIndex: number = parts.indexOf('folder');

        if (partIndex >= 0) {
            folderIdPart = parts[partIndex + 1];
        } else {
            partIndex = parts.indexOf('create-folder-template');

            if (partIndex >= 0) {
                folderIdPart = parts[partIndex + 1];
            }
        }

        // Return the numeric value (using '+') of the folder Id part.
        //return +parts[parts.indexOf('folder') + 1];
        return (folderIdPart != null ? +folderIdPart : 0);
    }
}
